import { getStaticImage } from "./static";
import { baseUrl } from "../config/globalVariables";
import { EmployeeAvatarDto } from "../redux/api-model/organization/company";

export function getProfileImageUrl(imageId?: string | null): string {
  return imageId
    ? baseUrl + "/file/account/" + imageId
    : getStaticImage("missing-avatar.png");
}

export function getProfileFullName(employee: EmployeeAvatarDto): string {
  return `${employee.firstName} ${employee.lastName}`;
}
